export default __webpack_public_path__ + "static/howFWAWorksStep1-b18d79aba2133f564994315e3de4d157.png";